import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../Settings.module.scss';
import Accordion from '../../../components/primitives/Accordion';
import { useUser } from '../../../app/hooks';
import { TpTemplateInfo } from '../../../api/models/assets';
import { isModifiableTemplateScope } from '../../../components/miscUtils';

interface TemplatesAccordionMenuProps {
  scopes: string[];
  scopeValue: string;
  activeSectionId: string;
  setActiveSectionId: (id: string) => void;
  setScopeValue: (arg0: string) => void;
  invalidTemplates: { [key: string]: TpTemplateInfo[] };
}

const TemplatesAccordionMenu = (props: TemplatesAccordionMenuProps) => {
  const { scopes, scopeValue, setScopeValue, activeSectionId, setActiveSectionId, invalidTemplates } = props;
  const sectionId = 'templates';
  const { user } = useUser();
  const [sectionIsActive, setSectionIsActive] = useState(false);

  let availableScopes = scopes;
  if (!user.isOrganizationAdmin) {
    availableScopes = scopes.filter((scope) => isModifiableTemplateScope(scope));
  }

  function onScopeItemClicked(scopeName: string) {
    setScopeValue(scopeName);
  }

  useEffect(() => {
    setSectionIsActive(sectionId == activeSectionId);
  }, [activeSectionId]);

  return (
    <>
      <div>
        <Accordion
          controllerElement={() => (
            <button className={styles.settingsTitleButton} onClick={() => setActiveSectionId(sectionId)}>
              Asset templates <FontAwesomeIcon icon={['fas', 'caret-down']} />
            </button>
          )}
          children={
            <>
              {availableScopes.map((scope: string, index: number) => (
                <div
                  key={index}
                  className={sectionIsActive && scopeValue == scope ? styles.scopeLineActive : styles.scopeLine}
                  onClick={() => {
                    setActiveSectionId(sectionId);
                    onScopeItemClicked(scope);
                  }}
                >
                  {scope}
                  {invalidTemplates[scope] && !!invalidTemplates[scope] && (
                    <FontAwesomeIcon
                      icon={['fas', 'exclamation-triangle']}
                      style={{ color: 'red', marginLeft: '5px' }}
                    />
                  )}
                </div>
              ))}
            </>
          }
          expanded={sectionIsActive}
          onChange={setSectionIsActive}
        ></Accordion>
      </div>
    </>
  );
};

export default TemplatesAccordionMenu;
